export const MAINTENANCE_LOGS_ALL_SENTINEL = 'all'

export interface MaintenanceLogsFilterParamInput {
  fromDate?: string
  toDate?: string
  hideEmptyData?: boolean
  selectedTypeIds?: number[]
  selectedSiteIds?: number[]
  selectedDepartmentIds?: number[]
  selectedUnitIds?: number[]
  calTaskIds?: number[]
  /** When set, included as instrument_id unless an override clears it. */
  selectedInstrumentId?: number | null
  overrides?: Record<string, string | undefined>
}

/**
 * Builds Maintenance Logs report query params.
 * An empty calTaskIds (and explicit undefined overrides) omits cal_task_ids so
 * "Show All" clears in place and stays cleared across navigation/refresh.
 * Explicit selectedInstrumentId is included by default so date / hide-empty / sheet
 * navigations cannot drop an in-scope instrument selection (AC6).
 */
export const buildMaintenanceLogsFilterParams = ({
  fromDate,
  toDate,
  hideEmptyData = false,
  selectedTypeIds = [],
  selectedSiteIds = [],
  selectedDepartmentIds = [],
  selectedUnitIds = [],
  calTaskIds = [],
  selectedInstrumentId = null,
  overrides = {},
}: MaintenanceLogsFilterParamInput): Record<string, string> => {
  const queryParams: Record<string, string> = {}

  if (fromDate) queryParams.from_date = fromDate
  if (toDate) queryParams.to_date = toDate
  if (hideEmptyData) queryParams.hide_empty_data = '1'
  if (selectedTypeIds.length > 0) queryParams.instrument_type_ids = selectedTypeIds.join(',')
  if (selectedSiteIds.length > 0) queryParams.site_ids = selectedSiteIds.join(',')
  if (selectedDepartmentIds.length > 0) queryParams.department_ids = selectedDepartmentIds.join(',')
  if (selectedUnitIds.length > 0) queryParams.unit_ids = selectedUnitIds.join(',')
  if (calTaskIds.length > 0) queryParams.cal_task_ids = calTaskIds.join(',')
  if (selectedInstrumentId != null) {
    queryParams.instrument_id = String(selectedInstrumentId)
  }

  Object.entries(overrides).forEach(([key, value]) => {
    if (value != null && value !== '' && value !== MAINTENANCE_LOGS_ALL_SENTINEL) {
      queryParams[key] = value
    } else {
      delete queryParams[key]
    }
  })

  return queryParams
}
